import React, { Fragment } from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import styles from './index.module.scss';
import HeadContainer from '../../../components/lm-d-s/head-container';
import { getImageFromS3 } from '../../../imageService';

const infoList = [
  {
    title: '1994',
    subtitle: 'PMI вийшла на український ринок',
    text: "Philip Morris International (PМІ) вийшла на український ринок у 1994 році та представлена ПрАТ «Філіп Морріс Україна» (ФМУ) та ТОВ «Філіп Морріс Сейлз енд Дистриб'юшн» (ФМСД). Головний український офіс Філіп Морріс знаходиться за адресою м. Київ, вул. Спаська, 30."
  },
  {
    title: '$755 млн',
    subtitle: 'Загальний обсяг інвестицій',
    text: 'Пріоритетними напрямками інвестування компанії стали бездимні продукти для нагрівання тютюну, інноваційний виробничий центр біля Харкова та нова фабрика на Львівщині, що почала працювати у травні 2024 року.'
  },
  {
    title: '34.8 млрд грн',
    subtitle: 'Податків сплачено до державного та міцевих бюджетів за 2024 рік',
    text: 'За період роботи в Україні ПрАТ «Філіп Морріс Україна» і ТОВ «Філіп Морріс Сейлз енд Дистриб’юшн» сплатили близько 15,3 млрд доларів податків до державного та місцевих бюджетів. З них у 2024 році- 34.8 млрд грн.'
  },
  {
    title: 'Соціальні проєкти',
    subtitle: 'Понад 413 млн грн на гуманітарні проєкти',
    text:
      'Компанія Філіп Морріс виділила понад 413 млн грн на гуманітарні проєкти від початку великої війни. Компанія сфокусувалась на трьох основних напрямах: допомозі медичним закладам, на відновленні пошкодженої інфраструктури та на реалізації соціальних проєктів.\n\n' +
      'У 2023 році ми продовжували підтримувати українців та допомогли поставити обладнання для лікарень Львівської, Вінницької, Сумської, Харківської, Миколаївської та Дніпропетровської областей на суму близько $550 тис.\n\n' +
      'Не залишилась без пітримки і рідна Харківщина, де знаходиться фабрика. Компанія допомогла з будівництвом укриття у Харківській області та поставкою генераторів для потреб деокупованих громад . Філіп Морріс допоміг БФ “Фундація імені професора Бакшеєва” з купівлею «Жінкомобіля» вартістю близько 1.5 млн. грн. - спеціального діагностичного авто для медичних оглядів жінок на деокупованих територіях Харківської, Херсонської та Донецької областей.\n\n' +
      'Протягом 2024-2025 років компанія виступила партнером реабілітаційних центрів Unbroken, Superhumans та U+, з якими компанія допомагає особам з інвалідністю пройти повноцінне фізичне й психоемоційне відновлення та мати доступ до високотехнологічного лікування.'
  },
  {
    title: 'Нова фабрика',
    subtitle: 'в Україні',
    text:
      'Компанія має інноваційний виробничий центр біля Харкова в селищі Докучаєвське. Він виготовляв продукцію як для українського, так і для закордонних ринків. На виробництві було задіяно більше тисячі осіб. Проте з початком повномасштабної війни компанія була змушена призупинити виробництво з міркувань безпеки працівників.\n\n' +
      'У 2024 році компанія ФМУ відкрила нову фабрику, в яку було проінвестовано близько $30 млн. Додатково компанія інвестувала близько 60 млн грн у сучасне укриття на території фабрики.\n\n' +
      'Власне виробництво в Україні дозволяє компанії краще контролювати якість та швидкість виробництва, а також логістичні ланцюги.\n\n' +
      'Філіп Морріс залишається одним з найбільших інвесторів в Україні навіть під час війни, що свідчить про беззаперечну віру в майбутнє країни.'
  },
  {
    title: 'Серед топ-5',
    subtitle: 'Найкращих роботодавців України 2025 року',
    text: 'У 2025 році Forbes Ukraine традиційно оприлюднив рейтинг найкращих роботодавців України, де Philip Morris посів четверте місце, чим компанія дуже пишається. Не меншим досягненням є перемога в номінації «Взірець турботи» за найкращий соціальний пакет серед роботодавців України. Наша компанія може пишатись рівнем eNPS- 92% та високою часткою співробітників/ць, які працюють більше 10 років. А також розміром заробітньої плати, яка у Philip Morris значно перевищує середні показники. Ну і, звичайно ж, ми не забуваємо про підтримку співробітників, які вступили до лав сил оборони, ми зберігаємо робочі місця та забезпечуємо необхідні матеріальні потреби. А також допомагаємо у фізичній реабілітації поранених військових-співробітників.\n\n'
  }
];

const InfoScreen = ({ setScreenNumber, setReviewScreenNumber }) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.infoContainer}
        style={{
          backgroundImage: `url("${getImageFromS3(
            'images/lm-double-splash/violet-background.png'
          )}")`
        }}
      >
        <HeadContainer setScreenNumber={setScreenNumber} />
        <span className={styles.title}>
          Філіп Морріс<br></br> Україна
        </span>
        {infoList.map((item, index) => (
          <Disclosure key={index} id={index.toString()}>
            {({ open }) => (
              <>
                <Disclosure.Button className={styles.panelButton}>
                  <div>
                    <p>{item.title}</p>
                    <p>{item.subtitle}</p>
                  </div>
                  {open ? (
                    <img
                      src="/images/lm-double-splash/white-minus.svg"
                      alt="open-tab-icon"
                    />
                  ) : (
                    <img
                      src="/images/lm-double-splash/white-plus.svg"
                      alt="open-tab-icon"
                    />
                  )}
                </Disclosure.Button>
                <Transition
                  as={Fragment}
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel className={styles.panelContent}>
                    {index === 5 ? (
                      <>
                        {`У 2025 році Forbes Ukraine традиційно оприлюднив `}
                        <a
                          href="https://forbes.ua/news/forbes-ta-robotaua-nagorodili-naykrashchikh-robotodavtsiv-ukraini-khto-ocholiv-reyting-25042025-29207"
                          target="_blank"
                          className={styles.link}
                        >
                          рейтинг
                        </a>
                        {` найкращих роботодавців України, де Philip Morris посів четверте місце, чим компанія дуже пишається. Не меншим досягненням є перемога в номінації «Взірець турботи» за найкращий соціальний пакет серед роботодавців України. Наша компанія може пишатись рівнем eNPS- 92% та високою часткою співробітників/ць, які працюють більше 10 років. А також розміром заробітньої плати, яка у Philip Morris значно перевищує середні показники. Ну і, звичайно ж, ми не забуваємо про підтримку співробітників, які вступили до лав сил оборони, ми зберігаємо робочі місця та забезпечуємо необхідні матеріальні потреби. А також допомагаємо у фізичній реабілітації поранених військових-співробітників.\n\n`}
                        <p className={styles.inviteToTeam}>
                          Хочеш стати частиною команди? Переходь за{' '}
                          <a
                            href="https://robota.ua/ru/company1063"
                            target="_blank"
                          >
                            посиланням
                          </a>
                          .
                        </p>
                      </>
                    ) : (
                      item?.text
                    )}
                  </Disclosure.Panel>
                </Transition>
              </>
            )}
          </Disclosure>
        ))}
        <div style={{ margin: '45px 0 10px 0' }}>
          <button
            className={styles.menuButton}
            onClick={() => setScreenNumber(1)}
          >
            Повернутися до меню
          </button>
          <button
            className={styles.reviewButton}
            style={{ marginTop: 10 }}
            onClick={setReviewScreenNumber}
          >
            Далі
          </button>
        </div>
      </div>
      <div className={styles.footer}>
        Дана інформація про продукт надається <br></br> відповідно до статті 15
        Закону України <br></br> «Про захист прав споживачів»
      </div>
    </div>
  );
};

export default InfoScreen;
